import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30f8a466"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Crear nueva incidencia", -1))
const _hoisted_2 = { class: "unordered-list steps" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "step" }, "Paso 1:"),
  /*#__PURE__*/_createTextVNode(" Seleccione una categoría a la que corresponda la incidencia. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step" }, "Paso 2:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step" }, "Paso 3:", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "step" }, "Paso 4:"),
  /*#__PURE__*/_createTextVNode(" Introduzca una descripción de la incidencia así como datos de contacto (obligatorios). ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step" }, "Envío:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ver sus incidencias", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "version"
}

import { ref } from 'vue'
import { IonPage, IonHeader, IonToolbar, IonContent, IonIcon, IonText, onIonViewWillEnter } from '@ionic/vue'
import { duplicateOutline, layersOutline, navigateCircleOutline, locateOutline } from 'ionicons/icons'
import { App } from '@capacitor/app'

import FormToolbar from '@/components/FormToolbar'
import { fileValidationService } from '@/services/file-validation-service'
import { deviceService } from '@/services/device-service'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpView',
  setup(__props) {

const publicPath = process.env.BASE_URL

const maxFiles = fileValidationService.maxNumFiles
const version = ref<string>()

onIonViewWillEnter(async () => {
  if (deviceService.isWeb()) return
  const { version: v } =  await App.getInfo()
  version.value = v
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(FormToolbar), {
                title: "Guía de uso",
                "home-button": false,
                "back-button-default": "/"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("p", null, [
            _createTextVNode("Desde la página de inicio pulse en botón "),
            _createVNode(_unref(IonText), { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("ENTRAR")
              ]),
              _: 1
            }),
            _createTextVNode(" o pulse el botón "),
            _createVNode(_unref(IonText), { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("Nueva")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_unref(IonIcon), {
              icon: _unref(duplicateOutline),
              color: "primary"
            }, null, 8, ["icon"])
          ]),
          _createElementVNode("ul", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("li", null, [
              _hoisted_4,
              _createTextVNode(" Si lo desea puede tomar o seleccionar fotografías (máximo " + _toDisplayString(_unref(maxFiles)) + ") con su dispositivo (opcional). ", 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_5,
              _createTextVNode(" Geolocalice la incidencia. Por defecto la app automáticamente seleccionará donde se encuentre. Puede forzar la selección de su posición actual pulsando el botón "),
              _createVNode(_unref(IonIcon), {
                icon: _unref(locateOutline),
                color: "primary"
              }, null, 8, ["icon"]),
              _createTextVNode(". También puede seleccionar la ubicación utilizando el buscador o desplazando el marcador "),
              _createElementVNode("img", {
                src: `${_unref(publicPath)}img/marker-icon.png`,
                alt: "Marker icon",
                class: "marker-map-redux"
              }, null, 8, _hoisted_6),
              _createTextVNode(". Una vez la dirección sea la deseada pulse en el botón "),
              _createVNode(_unref(IonText), { color: "success" }, {
                default: _withCtx(() => [
                  _createTextVNode("Continuar")
                ]),
                _: 1
              })
            ]),
            _hoisted_7,
            _createElementVNode("li", null, [
              _hoisted_8,
              _createTextVNode(" Confirme que los datos son correctos y pulse en el botón "),
              _createVNode(_unref(IonText), { color: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode("Enviar")
                ]),
                _: 1
              }),
              _createTextVNode(". ")
            ])
          ]),
          _hoisted_9,
          _createElementVNode("p", null, [
            _createTextVNode("Puede ver el listado de sus incidencias pulsando en "),
            _createVNode(_unref(IonText), { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("Tramitadas")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_unref(IonIcon), {
              icon: _unref(layersOutline),
              color: "primary"
            }, null, 8, ["icon"]),
            _hoisted_10,
            _createTextVNode(" Pulsando en cada elemento de dicho listado puede ver el detalle de dicha incidencia.")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode("Si desea ver sus incidencias geolocalizadas en el plano pulse en el boton "),
            _createVNode(_unref(IonText), { color: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("Plano")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_unref(IonIcon), {
              icon: _unref(navigateCircleOutline),
              color: "primary"
            }, null, 8, ["icon"])
          ]),
          (version.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Versión " + _toDisplayString(version.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})